// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2vMMs","filesListContainer":"PosDisputesFiles_filesListContainer__3sbMn","filesButton":"PosDisputesFiles_filesButton__36Mnj"};